import { render, staticRenderFns } from "./fw-status-flag.vue?vue&type=template&id=985e5aac&"
import script from "./fw-status-flag.vue?vue&type=script&lang=ts&"
export * from "./fw-status-flag.vue?vue&type=script&lang=ts&"
import style0 from "./fw-status-flag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports